import { AppStateEnum } from '../../../../../main/types/app-state.types.ts';

import { updateAppStateThunk } from '../../../../slices/app-state/thunks/update-app-state.thunk.ts';

import { BaseWritingStateChangeHandlerUtil } from './base-writing.handler.ts';

/**
 * Handler for app writing demonstration steps
 * Used in SoundsWriting tasks for showing letter formation
 */
export class AppWriteStateChangeHandlerUtil extends BaseWritingStateChangeHandlerUtil {
  private static _instance: AppWriteStateChangeHandlerUtil;

  private constructor() {
    super();
  }

  static get instance(): AppWriteStateChangeHandlerUtil {
    if (!AppWriteStateChangeHandlerUtil._instance) {
      AppWriteStateChangeHandlerUtil._instance = new AppWriteStateChangeHandlerUtil();
    }
    return AppWriteStateChangeHandlerUtil._instance;
  }

  protected getHandlerName(): string {
    return 'AppWrite';
  }

  /**
   * Returns the next state after ReadyToStart
   * For AppWrite, we transition to Writing state
   */
  protected override async getNextStateAfterReadyToStart(): Promise<AppStateEnum | null> {
    return Promise.resolve(null);
  }

  /**
   * Handles state change to Writing
   * Demonstrates the letter formation with animation
   */
  protected override async onWriting(): Promise<void> {
    console.log(`${this.getHandlerName()} onWriting`);

    this.resetBallPosition();

    // Animate letter drawing
    await this.animateLetterDrawing();

    // Transition to ready for next step when demonstration is complete
    const dispatch = await this.reduxStoreUtil.getDispatch();
    await dispatch(updateAppStateThunk({ state: AppStateEnum.ReadyForNextStep })).unwrap();
  }

  /**
   * Handles state change to Aborting
   */
  protected override async onAborting(): Promise<void> {
    console.log(`${this.getHandlerName()} onAborting`);
    await super.onAborting();
  }
}

export const getAppWriteStateChangeHandlerUtil = (): AppWriteStateChangeHandlerUtil =>
  AppWriteStateChangeHandlerUtil.instance;
